import { render, staticRenderFns } from "./ot-add-edit-document-dialog.vue?vue&type=template&id=593168e8&scoped=true&"
import script from "./ot-add-edit-document-dialog.vue?vue&type=script&lang=ts&"
export * from "./ot-add-edit-document-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./ot-add-edit-document-dialog.vue?vue&type=style&index=0&id=593168e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593168e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VAlert,VFileInput,VForm,VIcon,VMenu})
